/**
 * Périodicité financière — alignée sur vendor/otipass/core define.inc.php :
 * ANNUALY = 1, QUARTERLY = 2, MONTHLY = 3 (commentaire « finance periodicity » côté métier)
 */
export const FINANCE_PERIODICITY_OPTIONS = [
	{ value: 1, tKey: '1' },
	{ value: 2, tKey: '2' },
	{ value: 3, tKey: '3' },
];

/** Devises (codes ISO 4217) — étape Gestion financière (value = code ISO, affichage via i18n catalog.currency.XXX) */
export const FINANCE_CURRENCY_ISO_OPTIONS = [
	{ value: 'EUR' },
	{ value: 'USD' },
	{ value: 'CHF' },
	{ value: 'XOF' },
	{ value: 'TND' },
	{ value: 'GBP' },
	{ value: 'INR' },
	{ value: 'KES' },
	{ value: 'SAR' },
	{ value: 'MXN' },
	{ value: 'SEK' },
];

export const PJ_TYPES = [
	{ value: "Pièce d'identité", tKey: 'id' },
	{ value: 'Justificatif de domicile', tKey: 'home' },
	{ value: "Avis d'imposition", tKey: 'tax' },
	{ value: 'Autre', tKey: 'other' },
];

/** Comparaison de fonctionnalités (valeurs métier inchangées) */
export const FEATURE_FORM_PJ = 'Gestion des Pièces justificatives';
export const FEATURE_BOUTIQUE_TARIF = 'Tarif préférentiel renouvellement';
export const FEATURE_PAIEMENT_CB = 'Paiement en CB/PayPal';

export const PAYMENT_GATEWAYS = [
	{ value: 'SystemPay', tKey: 'SystemPay' },
	{ value: 'Atos', tKey: 'Atos' },
	{ value: 'Payrexx', tKey: 'Payrexx' },
	{ value: 'Twint (via Payrexx)', tKey: 'Twint' },
	{ value: 'PayPal', tKey: 'PayPal' },
	{ value: 'Monetico', tKey: 'Monetico' },
	{ value: 'OrangeMoney', tKey: 'OrangeMoney' },
	{ value: 'PayFip', tKey: 'PayFip' },
	{ value: 'Paytrail', tKey: 'Paytrail' },
	{ value: 'PayBox', tKey: 'PayBox' },
	{ value: 'Avizi', tKey: 'Avizi' },
	{ value: 'Wave', tKey: 'Wave' },
	{ value: 'Autre', tKey: 'Autre' },
];

export const USER_DATA_FIELDS = {
	Civilité: { UUID: false },
	Nom: { UUID: true },
	Prénom: { UUID: true },
	'Date de naissance': { UUID: true },
	'Adresse email': { UUID: true },
	'N° rue': { UUID: false },
	Rue: { UUID: false },
	"Complément d'adresse": { UUID: false },
	'Code postal': { UUID: true },
	Ville: { UUID: false },
	Pays: { UUID: false },
	'Tél. 1': { UUID: false },
	'Tél. 2': { UUID: false },
};

export const FORMULAIRE_OTIPASS_FEATURES = [
	{ value: 'Compte famille', tKey: 'compte' },
	{ value: 'Gestion des Pièces justificatives', tKey: 'pj' },
	{ value: 'Captcha / anti-bot', tKey: 'captcha' },
	{ value: 'Consentement RGPD', tKey: 'rgpd' },
];

export const BOUTIQUE_OTIPASS_FEATURES = [
	{ value: 'Achat Pass courte durée', tKey: 'passCourt' },
	{ value: 'Achat Pass longue durée', tKey: 'passLong' },
	{ value: 'Renouvellement Pass longue durée', tKey: 'renew' },
	{ value: 'Tarif préférentiel renouvellement', tKey: 'tarif' },
	{ value: 'Commande de plusieurs Pass', tKey: 'multi' },
	{ value: 'Achat carte cadeau', tKey: 'cadeau' },
	{ value: "Ajout/Suppression d'un code promo", tKey: 'promo' },
	{ value: 'Achat rapide sans création de compte', tKey: 'quick' },
	{ value: "Saisie de la date d'arrivée pour activation automatique de Pass à cette date", tKey: 'activation' },
	{ value: 'Paiement en CB/PayPal', tKey: 'cb' },
	{ value: 'Paiement en points (otipoints)', tKey: 'otipoints' },
	{ value: 'Paiement par chèque', tKey: 'cheque' },
	{ value: 'Paiement en chèque-vacances', tKey: 'chequeVac' },
	{ value: 'Paiement en plusieurs fois', tKey: 'facility' },
	{ value: 'Paiement récurrent (abonnements)', tKey: 'recurrent' },
	{ value: 'Programme de fidélité (otipoints)', tKey: 'loyalty' },
	{ value: 'Envoi immédiat e-ticket', tKey: 'eticket' },
	{ value: 'Envoi postal supports physiques', tKey: 'post' },
	{ value: 'Retrait en point de vente', tKey: 'pickup' },
	{ value: 'Facturation', tKey: 'invoice' },
	{ value: 'Multidevise', tKey: 'multiDev' },
	{ value: 'Multilangue', tKey: 'multiLang' },
	{ value: 'Paiement différé', tKey: 'deferred' },
	{ value: 'Paiement par virement', tKey: 'transfer' },
	{ value: 'SSO (FranceConnect)', tKey: 'sso' },
];

export const champsFormula = [
	{ name: 'package', tKey: 'package', type: 'text', colWidth: '30%' },
	{ name: 'reference', tKey: 'reference', type: 'text', maxLength: 5, className: 'uppercase', colWidth: '12%' },
	{ name: 'duree', tKey: 'duree', type: 'number', min: 1, step: 1 },
	{ name: 'periode', tKey: 'periode', type: 'number', min: 1, step: 1 },
	{ name: 'tarifAdulte', tKey: 'tarifAdulte', type: 'number', min: 0, step: 0.01 },
	{ name: 'tarifEnfant', tKey: 'tarifEnfant', type: 'number', min: 0, step: 0.01 },
	{ name: 'accompagnants', tKey: 'accompagnants', type: 'number', min: 0, max: 9, step: 1, colWidth: '8%' },
];
